const numberValue = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const getSectionCode = (index, order) => {
  const normalizedIndex = Math.max(0, numberValue(order) || index);
  const alphabetIndex = normalizedIndex % 26;
  const alphabetCycles = Math.floor(normalizedIndex / 26);
  const baseChar = String.fromCharCode(65 + alphabetIndex);
  return alphabetCycles > 0 ? `${baseChar}${alphabetCycles}` : baseChar;
};

export const normalizeBoQItem = (item, section, itemIndex = 0) => {
  const quantity = numberValue(item?.quantity);
  const materialCost = numberValue(item?.material_estimation);
  const labourCost = numberValue(item?.labor_estimation);
  const totalCost = materialCost + labourCost;
  const rate = quantity > 0 ? totalCost / quantity : 0;
  const actualMaterial = numberValue(item?.Actual_material);
  const actualLabour = numberValue(item?.Actual_labor);
  const actualCost = actualMaterial + actualLabour;
  console.log("BoQ item", item)
  return {
    id: item?.id,
    code: `${section.code}${itemIndex + 1}`,
    description: item?.item_name || "Untitled Item",
    unit: item?.uom || "-",
    quantity,
    rate,
    labourCost,
    materialCost,
    totalCost,
    profitPercent: numberValue(item?.profit_margin),
    status: item.status ?? "Plan",
    executedQty: 0,
    actualCost,
    actualMaterial,
    actualLabour,
    taskId: item?.task ?? null,
    taskName: item?.task_name ?? "",
    raw: item,
  };
};

export const normalizeBoQSection = (section, items = [], index = 0) => {
  const sectionCode = getSectionCode(index, section?.order);
  const normalizedSection = {
    id: section?.id,
    code: sectionCode,
    name: section?.section_name || `SECTION ${index + 1}`,
    order: numberValue(section?.order),
    site: section?.site,
    taskGroup: section?.task_group ?? null,
    createdBy: section?.created_by ?? null,
    raw: section,
    items: [],
  };

  normalizedSection.items = items.map((item, itemIndex) =>
    normalizeBoQItem(item, normalizedSection, itemIndex)
  );

  return normalizedSection;
};

export const formatCurrency = (amount) => {
  const normalizedAmount = numberValue(amount);
  if (normalizedAmount >= 100000) return `₹${(normalizedAmount / 100000).toFixed(2)}L`;
  if (normalizedAmount >= 1000) return `₹${(normalizedAmount / 1000).toFixed(1)}K`;
  return `₹${normalizedAmount.toLocaleString("en-IN")}`;
};

export const getSectionTotals = (section) => {
  const totalBudget = section.items.reduce((sum, item) => sum + item.totalCost, 0);
  const totalActual = section.items.reduce((sum, item) => sum + numberValue(item.actualCost), 0);
  const totalLabour = section.items.reduce((sum, item) => sum + numberValue(item.labourCost), 0);
  const totalMaterial = section.items.reduce((sum, item) => sum + numberValue(item.materialCost), 0);

  return { totalBudget, totalActual, totalLabour, totalMaterial };
};

export const getAllTotals = (sections = []) => {
  const totalBudget = sections.reduce(
    (sum, section) => sum + section.items.reduce((itemSum, item) => itemSum + item.totalCost, 0),
    0
  );
  const totalActual = sections.reduce(
    (sum, section) =>
      sum + section.items.reduce((itemSum, item) => itemSum + numberValue(item.actualCost), 0),
    0
  );
  const totalLabour = sections.reduce(
    (sum, section) =>
      sum + section.items.reduce((itemSum, item) => itemSum + numberValue(item.labourCost), 0),
    0
  );
  const totalMaterial = sections.reduce(
    (sum, section) =>
      sum + section.items.reduce((itemSum, item) => itemSum + numberValue(item.materialCost), 0),
    0
  );
  const totalItems = sections.reduce((sum, section) => sum + section.items.length, 0);
  const totalProfit = sections.reduce(
    (sum, section) =>
      sum + section.items.reduce((itemSum, item) => itemSum + numberValue(item.profitPercent), 0),
    0
  );
  const avgProfit = totalItems > 0 ? totalProfit / totalItems : 0;

  return { totalBudget, totalActual, totalLabour, totalMaterial, totalItems, avgProfit };
};
